<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Condutores</span>
        <button class="action-button ml-2 my-1" (click)="create()">Novo Condutor</button>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-12 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="filterOn" (click)="deleteFilter()" class="list-select ml-2 my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="showFilter(modalfilter)" class="list-select ml-2 my-1">
                                <button class="list-select" type="button">
                                    <span *ngIf="!filterOn"><img src="assets/icons/filter.svg" style="height: 15px;">
                                        Aplicar filtro</span>
                                    <span *ngIf="filterOn"><img src="assets/icons/filter-purple.svg"
                                            style="height: 15px;"> Alterar filtro</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)"
                                    class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class=" table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <!-- <th></th> -->
                            <th>Nome</th>
                            <th>CPF</th>
                            <th>Matricula</th>
                            <th>CNH</th>
                            <th>Veiculos</th>
                            <th></th>
                        </thead>
                        <tbody class="list-table-row" id="accordion">
                            <ng-container
                                *ngFor="let item of conductors | paginate : { itemsPerPage: showItem, currentPage: currentPage, totalItems: totalItems, id: 'vehicles' }">
                                <tr>
                                    <!-- <td>
                                        <mat-checkbox [attr.id]="item.id" class="" color="primary"
                                            [(ngModel)]="item.selected" (change)="selectElement(item)"
                                            [disabled]="linkedVehicle(item?.vehicles)">
                                        </mat-checkbox>
                                    </td> -->
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.document | cpf }}</td>
                                    <td>{{ item.register }}</td>
                                    <td>{{ item.cnh }}</td>
                                    <td>{{ item.vehicles?.length }}</td>
                                    <td>
                                        <div ngbDropdown class="d-inline-block menu-option  d-flex justify-content-end"
                                            placement="left">
                                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                                <img src="assets/icons/menu.png" />
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                <section class="custom-context-menu">
                                                    <div ngbDropdownItem (click)="edit(item.collaboratorId)">
                                                        <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                                        Editar
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <div *ngIf="!conductors || conductors == [] || conductors.length == 0" class="text-center">
                        Nenhum registro carregado.
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="vehicles" (pageChange)="pagedConductor($event)" responsive="true"
                            previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>

            <!-- <div class="row button-container mt-5 mb-3">
                <div class="col-12 text-right">
                    <button type="submit" class="custom-button-back" (click)="goToBack()">
                        Voltar
                    </button>
                    <button type="submit" class="custom-button-full" (click)="link()">
                        Vincular
                    </button>
                </div>
            </div> -->
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #modalfilter let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Nome</mat-label>
                    <input [(ngModel)]="filters.name" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Documento</mat-label>
                    <input [(ngModel)]="filters.document" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Matricula</mat-label>
                    <input [(ngModel)]="filters.register" matInput type="text">
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Cnh</mat-label>
                    <input [(ngModel)]="filters.cnh" matInput type="text">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>
